import { Card, CardActionArea, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useState } from "react";
import DialogEdit from "../DialogEdit/DialogEdit";
import CardMediaImage from "./CardMediaImage";

type ShowImageProps = {
  title: string,
  defaultImage: any,
  image?: any,
  tabIndex?: number,
  uploadNewPhoto: (newImage: any) => void,
  alt?: string,
  circle?: boolean,
  small?: boolean,
  noEdit?: boolean,
  noAction?: boolean,
  onFocus?: (event: any) => void,
};

const useStyle = makeStyles({
  card: {
    width: "100%",
  },
  root: {
    display: "flex",
    height: "100%",
  },
  circle: {
    borderRadius: "50%",
    height: "15em",
    width: "15em",
  },
  circleSmall: {
    borderRadius: "50%",
    height: "13em",
    width: "13em",
  },
  center: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
  },
  action: {
    height: "100%",
  },
});

const ShowImage = ({
  title,
  alt,
  image,
  uploadNewPhoto,
  defaultImage,
  tabIndex,
  circle,
  small,
  noEdit,
  noAction,
  onFocus,
}: ShowImageProps) => {
  const [openDialog, setOpenDialog] = useState(false);
  const classes = useStyle();
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleOpen = () => {
    if (noAction) return;
    setOpenDialog(true);
  };
  const takeNewPhoto = (news: any) => {
    uploadNewPhoto(news);
  };

  return (
    <div className={circle ? classes.center : classes.root}>
      <Card
        className={clsx(classes.card, {
          [classes.circle]: circle && !small,
          [classes.circleSmall]: circle && small,
        })}
      >
        {noAction ? (
          <CardMediaImage
            defaultImage={defaultImage}
            src={image}
            onClick={handleOpen}
            circle={circle}
            small={small}
            alt={alt}
          />
        ) : (
          <CardActionArea className={classes.action} onFocus={onFocus}>
            <CardMediaImage
              defaultImage={defaultImage}
              src={image}
              onClick={handleOpen}
              circle={circle}
              small={small}
              alt={alt}
            />
          </CardActionArea>
        )}
      </Card>
      <DialogEdit
        title={title}
        isImage={image && image !== ""}
        image={image ? image : defaultImage}
        handleClose={handleClose}
        open={openDialog}
        onAccept={takeNewPhoto}
        noEdit={noEdit}
      />
    </div>
  );
};

export default ShowImage;
